module.exports = __webpack_public_path__ + "img/docs-active.4e73694a.svg";